import { CloseOutline } from 'antd-mobile-icons';
import styles from './index.module.scss';
import { Popup } from 'antd-mobile';
import TwoDayTimeline, { TimeRange } from './components/Timeline';
import { PlanType } from './util';
import { formatTimeRange } from '../EnergyUsePlan/util';
import { useEffect, useState } from 'react';
import { getAdminDetail, GetAdminDetailResponse } from '@/api/energy';
import dayjs from 'dayjs';
import { isEmpty, isNil } from 'lodash-es';

interface DetailProps {
  onCancel: () => void;
  params?: any;
  energyMediumId?: number;
}
const Detail = ({ onCancel, params, energyMediumId }: DetailProps) => {
  const [data, setData] = useState<GetAdminDetailResponse>({});
  const [energyPlanTag, setEnergyPlanTag] = useState<GetAdminDetailResponse['planList']>([]);
  const [delayAppTag, setDelayAppTag] = useState<GetAdminDetailResponse['planList']>([]);
  const [times, setTimes] = useState<TimeRange[]>([]);

  useEffect(() => {
    getAdminDetail({ ...params, energyMediumId }).then(res => {
      setData(res);
      setEnergyPlanTag(res.planList?.filter(item => item.type === PlanType.ENERGY));
      setDelayAppTag(res.planList?.filter(item => item.type === PlanType.DELAY_ENERGY));
      setTimes(
        res.planList?.map(item => ({
          start: item.startDateTime!,
          end: item.endDateTime!,
          type: item.type as PlanType,
        })) ?? []
      );
    });
  }, [params, energyMediumId]);

  return (
    <Popup visible={true} onClose={onCancel} position="bottom" className="actionMenu">
      <div className={styles.popupContainer}>
        <div className={styles.popupTitleContainer}>
          <div className={styles.popupTitle}>查看详情</div>
          <CloseOutline onClick={onCancel} />
        </div>
        <div className={styles.popupMain}>
          <div className={styles.table}>
            <div className={styles.tableRow}>
              <div className={styles.tableHead}>部门</div>
              <div className={styles.tableCell}>{data?.ownerOrgName}</div>
            </div>
            <div className={styles.tableRow}>
              <div className={styles.tableHead}>区域</div>
              <div className={styles.tableCell}>{data?.areaName}</div>
            </div>
            <div className={styles.tableRow}>
              <div className={styles.tableHead}>日期</div>
              <div className={styles.tableCell}>{dayjs(params?.day).format('YYYY-MM-DD')}</div>
            </div>
          </div>
          <TwoDayTimeline ranges={times} baseTime={params?.day} />
          {/* 下方时间段标签 */}
          <div className={styles.timeLabels}>
            <div className={styles.energyPlan}>
              <span className={styles.labelTitle}>用能计划</span>
              <div className={styles.tags}>
                {isEmpty(energyPlanTag)
                  ? '无'
                  : energyPlanTag?.map(e => (
                      <div className={`${styles.tag} ${styles.energyItem}`} key={e.startDateTime}>
                        {formatTimeRange(params?.day, e?.startDateTime, e?.endDateTime)}
                      </div>
                    ))}
              </div>
            </div>
            <div>
              <span className={styles.labelTitle}>延时用能申请</span>
              <div className={styles.tags}>
                {isEmpty(delayAppTag)
                  ? '无'
                  : delayAppTag?.map(d => (
                      <div className={`${styles.tag} ${styles.delayEnergyItem}`} key={d.startDateTime}>
                        {formatTimeRange(params?.day, d?.startDateTime, d?.endDateTime)}
                      </div>
                    ))}
              </div>
            </div>
            <div>
              <span className={styles.labelTitle}>用能计划时长</span>
              <div className={styles.value}>{data.energyUseDuration + '小时'}</div>
            </div>
            <div>
              <span className={styles.labelTitle}>延时用能时长</span>
              <div className={styles.value}>{data.delayEnergyUseDuration + '小时'}</div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default Detail;
